/**
 * capture-events — a tiny typed bridge so any surface can open the shell's
 * CaptureFab sheet (T12.1.5.1.2).
 *
 * The CaptureFab (mounted once by AppShell) owns the quick-add sheet. The
 * Planning cold-start CTA, the common-starter rows, and the Suggested-for-you
 * "+ Add" action all need to reach that same sheet rather than spawn a second
 * add flow. Rather than lift sheet state into a context that wraps the whole
 * shell, we use a window CustomEvent: `openCapture(prefill?)` dispatches it and
 * the CaptureFab listens. This keeps the inline-add path single (the FAB's
 * product-match + optimistic-add flow) with no prop drilling across the shell.
 *
 * `prefill` seeds the sheet's text field so a starter chip ("Milk") lands in the
 * field ready to submit — matching the prototype's cold-start "tap to add".
 */

export const CAPTURE_OPEN_EVENT = 'shopista:capture-open';

export interface CaptureOpenDetail {
  prefill?: string | undefined;
}

/** Open the shared capture sheet, optionally pre-filling the item name. */
export function openCapture(prefill?: string): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<CaptureOpenDetail>(CAPTURE_OPEN_EVENT, {
      detail: { prefill },
    }),
  );
}
